import { render, staticRenderFns } from "./statusInfo.vue?vue&type=template&id=3038f28c&scoped=true&"
import script from "./statusInfo.vue?vue&type=script&lang=js&"
export * from "./statusInfo.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=3038f28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038f28c",
  null
  
)

export default component.exports